import { RuntimeMediaQuery } from '@duda-co/responsive-styles/RuntimeMediaQuery';
import type { ResponsiveStylesStructured } from '@duda-co/responsive-styles/types/ResponsiveStylesTypes';
import Text, {
    TextDomTag,
} from 'client/widget-components/basicComponents/Text';
import React, { FC } from 'react';

interface ChoicesLimitMessageProps {
    message: string;
}

const ChoicesLimitMessage: FC<ChoicesLimitMessageProps> = ({ message }) => (
    <Text
        tag={TextDomTag.paragraph}
        data-auto='checkbox-choices-limit-message'
        domAttrs={{ role: 'status', 'aria-live': 'polite' }}
        styles={[messageDefaultStyles]}
    >
        {message}
    </Text>
);

const messageDefaultStyles: ResponsiveStylesStructured = {
    [RuntimeMediaQuery.COMMON]: {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        minHeight: '32px',
        padding: '6px 12px',
        margin: '8px 0 0',
        borderRadius: '8px',
        backgroundColor: '#F6F6F8',
        color: '#272B35',
        fontSize: '13px',
        lineHeight: '20px',
    },
};

export default ChoicesLimitMessage;
